var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-right-1"},[_c('BorderBoxView1',{attrs:{"title":"护理服务"}},[_c('div',{staticClass:"box-top"},[_c('XidiItem2',{attrs:{"list":_vm.xidiValue1}}),_c('XidiItem2',{attrs:{"list":_vm.xidiValue2}})],1),_c('div',{staticClass:"box-bottom"},[_c('dv-scroll-board',{attrs:{"config":_vm.config}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }